// GuidePage.js
import React from "react";
import { BookOpen, Layers, Edit } from "lucide-react";

const GuidePage = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl font-inter">
      <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-center text-indigo-800 mb-4 leading-tight">
          Bí Quyết Học Giỏi Online
        </h1>
        <p className="text-center text-lg md:text-xl text-gray-700 mb-10 max-w-2xl mx-auto">
          Để học giỏi, bạn không chỉ cần chăm chỉ mà còn cần một phương pháp học
          tập đúng đắn. Hãy tham khảo 3 bước sau để biến việc học online thành
          lợi thế của mình!
        </p>

        {/* Bước 1 */}
        <div className="bg-blue-50 rounded-2xl p-6 md:p-8 mb-8 shadow-inner">
          <div className="flex items-center justify-center mb-4 space-x-2">
            <BookOpen size={48} className="text-blue-800" />
            <h2 className="text-2xl md:text-3xl font-bold text-blue-800">
              Khóa Học
            </h2>
          </div>
          <div className="flex items-center mb-4">
            <div className="bg-blue-500 text-white rounded-full w-12 h-12 flex items-center justify-center font-bold text-2xl mr-4 shadow-md flex-shrink-0">
              1
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-blue-800">
              Tiếp thu kiến thức nền tảng
            </h2>
          </div>
          <ul className="list-disc pl-8 md:pl-10 text-gray-700 space-y-3">
            <li>
              <span className="font-semibold text-blue-600">
                Học từ video bài giảng:
              </span>{" "}
              Học qua video giúp bạn có thể **chủ động thời gian** và **học theo
              tốc độ của bản thân**.
            </li>
            <li>
              <span className="font-semibold text-blue-600">
                Ghi chép cẩn thận:
              </span>{" "}
              Dùng vở và bút để ghi lại các ý chính, công thức quan trọng. Điều
              này giúp bạn tập trung và ghi nhớ tốt hơn.
            </li>
            <li>
              <span className="font-semibold text-blue-600">
                Tua lại và xem lại:
              </span>{" "}
              Đừng ngại tua lại nếu bạn chưa hiểu rõ một đoạn nào đó. Xem lại
              video nhiều lần giúp kiến thức ngấm sâu hơn.
            </li>
          </ul>
        </div>

        {/* Bước 2 */}
        <div className="bg-green-50 rounded-2xl p-6 md:p-8 mb-8 shadow-inner">
          <div className="flex items-center justify-center mb-4 space-x-2">
            <Layers size={48} className="text-green-800" />
            <h2 className="text-2xl md:text-3xl font-bold text-green-800">
              Chuyên đề
            </h2>
          </div>
          <div className="flex items-center mb-4">
            <div className="bg-green-500 text-white rounded-full w-12 h-12 flex items-center justify-center font-bold text-2xl mr-4 shadow-md flex-shrink-0">
              2
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-green-800">
              Đào sâu và củng cố
            </h2>
          </div>
          <ul className="list-disc pl-8 md:pl-10 text-gray-700 space-y-3">
            <li>
              <span className="font-semibold text-green-600">
                Học chuyên đề:
              </span>{" "}
              Sau khi nắm vững kiến thức cơ bản, hãy tìm các chuyên đề để đào
              sâu vào từng phần kiến thức.
            </li>
            <li>
              <span className="font-semibold text-green-600">
                Làm bài tập theo thứ tự:
              </span>{" "}
              Các bài tập trong chuyên đề thường được sắp xếp từ dễ, trung bình
              đến khó. Hãy làm theo đúng thứ tự để nâng cao kỹ năng một cách
              vững chắc.
            </li>
            <li>
              <span className="font-semibold text-green-600">
                Luyện tập đến khi thành thạo:
              </span>{" "}
              Chuyên đề có số lượng bài tập rất nhiều và đa dạng về dạng bài,
              giúp bạn luyện tập cho đến khi làm chủ được kiến thức đó.
            </li>
          </ul>
        </div>

        {/* Bước 3 */}
        <div className="bg-yellow-50 rounded-2xl p-6 md:p-8 mb-8 shadow-inner">
          <div className="flex items-center justify-center mb-4 space-x-2">
            <Edit size={48} className="text-yellow-800" />
            <h2 className="text-2xl md:text-3xl font-bold text-yellow-800">
              Giải đề
            </h2>
          </div>
          <div className="flex items-center mb-4">
            <div className="bg-yellow-500 text-white rounded-full w-12 h-12 flex items-center justify-center font-bold text-2xl mr-4 shadow-md flex-shrink-0">
              3
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-yellow-800">
              Kiểm tra và đánh giá
            </h2>
          </div>
          <ul className="list-disc pl-8 md:pl-10 text-gray-700 space-y-3">
            <li>
              <span className="font-semibold text-yellow-600">
                Làm bài thi thử:
              </span>{" "}
              Sử dụng các bộ đề thi để kiểm tra năng lực và xác định kiến thức
              bạn còn yếu.
            </li>
            <li>
              <span className="font-semibold text-yellow-600">
                Đánh giá kết quả:
              </span>{" "}
              Xem lại các câu trả lời sai và tìm hiểu vì sao bạn làm sai.
            </li>
            <li>
              <span className="font-semibold text-yellow-600">
                Lấp đầy lỗ hổng:
              </span>{" "}
              Quay lại bước 1 và 2 để củng cố những phần kiến thức bạn còn thiếu
              sót.
            </li>
          </ul>
        </div>

        <p className="text-center text-lg md:text-xl text-gray-700 mt-10 italic">
          Với phương pháp học tập hiệu quả, nền tảng của chúng tôi giúp học sinh
          tự tin tiến bộ và phụ huynh dễ dàng đồng hành cùng con.
        </p>
      </div>
    </div>
  );
};

export default GuidePage;
